import { useSelector } from 'react-redux'
import { getDefaultAirport } from 'selectors/flightsSelectors'

function useDefaultAirport() {
  return useSelector((state: App.State) => getDefaultAirport(state))
}

export default useDefaultAirport
